import React from 'react';
import { SelectArrow, TickMarkCircle, TickMarkBlankCircle, TickMark } from './Icons';


const ListFilter = (props) => {

  const {
          filterValues,
          filterValuesOnly,
          filterActive,
          filterOpen,
          filterTitle,
          filterName,
          handleFilter,
          handleFilterEntry,
        } = props;


  const filters = () => {
    if (filterValues instanceof Object && filterValues instanceof Array) {
      const output = filterValues.map(t => {
          const active = filterActive[filterName].includes(t);
          return (
            <div key={t} id={t} className='flex-container-space filter-entry-container' onClick={(e) => handleFilterEntry(e, filterName)}>
              <div className='filter-entry'>
                <span className='spacer'></span>
                <p className={`${(active) ? 'color-invert' : 'color-invert-dark'} inline-style`}>
                  {t}
                </p>
              </div>
              {active && <TickMark/>}
            </div>
          )
        }
      )
      return output;
    }

    else {
      const output = Object.keys(filterValues).map(t => {
          const active = filterActive[filterName].includes(t);
          return (
            <div key={t} id={t} className='flex-container-space filter-entry-container' onClick={(e) => handleFilterEntry(e, filterName)}>
              <div className='filter-entry'>
              <svg height="11" width="11">
                <circle cx="6" cy="6" r="5" stroke="white" strokeWidth="0" fill={(active) ? filterValues[t] : 'var(--grey4)'} />
              </svg>
              <p className={`${(active) ? 'color-invert' : 'color-invert-dark'} inline-style`}>
                {t}
              </p>
              </div>
              {active && <TickMark/>}
            </div>
          )
        }
      )
      return output;
    }
  }


  const allFiltersSelected=(Object.keys(filterValues).length === filterActive[filterName].length);


  return (
    <div className={`filter-tab ${(filterOpen===filterName) ? 'expanded' : 'closed' }`}>
      <div className='filter-expander' id={filterName} onClick={(e) => handleFilter(e)}>
        <div>
          <h2 className='color-invert'>{ filterTitle }</h2>
          <p className='color-invert'>{(allFiltersSelected) ? "All" : filterActive[filterName].length + ' of ' + Object.keys(filterValues).length } Selected</p>
        </div>
        <SelectArrow className={(filterOpen===filterName) ?  'arrow' : 'arrow-spin-90' }/>
    </div>
      <div className='filter-list'>

        <div className='filter-select-all flex-container-left' onClick={(e) => handleFilterEntry(e, filterName, filterValuesOnly, 'multi')}>
          { allFiltersSelected && <TickMarkCircle className='inline-style'/> }
          { !allFiltersSelected && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Select All</p>
        </div>

        {filters()}
      </div>
    </div>
  )
}

export default ListFilter;
